




































import { Component, Vue } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'
import { mapState, mapMutations } from 'vuex'

@Component({
  computed: {
    ...mapState({
      username: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      accountType: ({ gamblingContext }: any): string => gamblingContext.accountType
    })
  }
})
export default class AccountNavigation extends Vue {
  @Mutation('setAccountType') setAccountType: any
}
